import { render, staticRenderFns } from "./ResourceIndex.vue?vue&type=template&id=5183c4fa&scoped=true&"
import script from "./ResourceIndex.vue?vue&type=script&lang=js&"
export * from "./ResourceIndex.vue?vue&type=script&lang=js&"
import style0 from "./ResourceIndex.vue?vue&type=style&index=0&id=5183c4fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5183c4fa",
  null
  
)

export default component.exports